<template>
  <div
    :class="[
      'inline-flex items-center rounded-full font-medium max-w-full',
      compact ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs',
      CARRIERS[carrier].bgColor,
      CARRIERS[carrier].color,
    ]"
    :title="displayName"
  >
    <i :class="CARRIERS[carrier].icon + (showName ? ' mr-1 shrink-0' : '')"></i>
    <span v-if="showName" class="truncate">{{ displayName }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CARRIERS } from '@/types/carrier'
import type { CarrierType } from '@/types/carrier'

interface Props {
  carrier: CarrierType
  showName?: boolean
  compact?: boolean
  label?: string
}

const props = withDefaults(defineProps<Props>(), {
  showName: true,
  compact: false,
})

const displayName = computed(
  () => props.label?.trim() || CARRIERS[props.carrier].name,
)
</script> 